import { func_validation } from "functions";

export const formInput_funcUtility = {

    handleInputFocus_onEnter_selectInput,

    handleInputKeyPress_onEnter_blurInput,
        
	convertToReactSelectArray,
	convertToReactSelectArrayCustom,
	getValidatedSelection,

	getSelectionFromValue,

};

function handleInputFocus_onEnter_selectInput(e, extendSelect) {
    if (e && e.target && e.target.select) {
		e.target.select();
		if (extendSelect) extendSelect();
	}
}

function handleInputKeyPress_onEnter_blurInput(e, extendEnter) {
    if (e && e.target && e.target.blur && e.key === "Enter") {
		e.target.blur();
		if (extendEnter) extendEnter();
	}
}

// Array of Selections elements are not objects, just values
function convertToReactSelectArray(arrayOfSelections, func_formatLabel) {
	let selections = [];
	
    if (func_validation.isArrayNotEmpty(arrayOfSelections)) {
        arrayOfSelections.map((selection)=>{

            selections.push({
                value: selection, 
                label: (func_validation.isFunction(func_formatLabel))?func_formatLabel(selection):selection, 
			});
			
        });
	}
	
    return selections;
}

// Array of Selections elements are objects, thus, require propNamevalue and propNameLabel
function convertToReactSelectArrayCustom(arrayOfSelections, propNameValue, propNameLabel, func_formatLabel) {
	let selections = [];
	
    if (func_validation.isArrayNotEmpty(arrayOfSelections)) {
        arrayOfSelections.map((selection)=>{

			if (func_validation.isObjectNotEmpty(selection)) {
				let value = func_validation.getObjectPropertyValue(selection, propNameValue, "");
				let label = func_validation.getObjectPropertyValue(selection, propNameLabel, "");

				if (func_validation.isStringTrimNotEmpty(value) && 
					func_validation.isStringTrimNotEmpty(label)) {

					selections.push({
						...selection,
						value: value, 
						label: (func_validation.isFunction(func_formatLabel))?func_formatLabel(label):label,
					});

				}
			}
			
        });
	}
	
    return selections;
}

function getValidatedSelection(selection, selectionList, selectionDefault) {
	let retVal = (func_validation.isStringTrimNotEmpty(selectionDefault))?selectionDefault:"";

	if (func_validation.isStringTrimNotEmpty(selection) && 
		func_validation.isArrayNotEmpty(selectionList)) {
		selectionList.some((selectionListItem)=>{
			let selectionVal = selectionListItem.value;
			
			if (func_validation.isStringEqual_caseInsensitive(selection, selectionVal)) {
				retVal = func_validation.getTrimmedString(selectionVal);
				return true;
			}
		});
	}

	return retVal;
}

function getSelectionFromValue(selectedValue, arrayOfSelections, propNameValue, propNameLabel) {
	let matchingValue = "";
    
    if (func_validation.isArrayNotEmpty(arrayOfSelections)) {

        arrayOfSelections.map((selection)=>{

			if (func_validation.isObjectNotEmpty(selection)) {
				let value = func_validation.getObjectPropertyValue(selection, propNameValue, "");
                let label = func_validation.getObjectPropertyValue(selection, propNameLabel, "");

				if (func_validation.isStringTrimNotEmpty(value) && 
					func_validation.isStringTrimNotEmpty(label) &&
					func_validation.isNumberWithinRange(value, { equal: selectedValue })) { 
					
					matchingValue = label; 
				}
			}
			
        });
	}
    
    return matchingValue;
}


